<template>
  <div class="container">
    <div class="header">
      <h1>翻译服务订阅计划</h1>
      <p class="subtitle">灵活定价方案，满足不同的AI翻译需求，提升您的翻译效率与质量</p>
    </div>

    <div class="plans-container">
      <!-- 免费版卡片 -->
      <div class="plan-card free-card">
        <div class="plan-badge">当前计划</div>
        <div class="plan-header">
          <h2 class="plan-name">免费版</h2>
          <div class="plan-price free-price">￥0<span class="price-period">/月</span></div>
          <p class="plan-description">适合轻度翻译需求，体验基础翻译功能</p>
        </div>

        <div class="features-list">
          <div class="feature">
            <div class="feature-icon free-icon">
              <i class="fas fa-clock"></i>
            </div>
            <div class="feature-text">
              <div>排队翻译</div>
              <div class="feature-note">翻译任务需排队等待，非优先处理</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon free-icon">
              <i class="fas fa-chart-bar"></i>
            </div>
            <div class="feature-text">
              <div>每日翻译数量限制</div>
              <div class="feature-note">每天最多翻译10次，适合轻度使用</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon free-icon">
              <i class="fas fa-language"></i>
            </div>
            <div class="feature-text">
              <div>基础翻译功能</div>
              <div class="feature-note">支持文本翻译，常规文档格式</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon free-icon">
              <i class="fas fa-ban"></i>
            </div>
            <div class="feature-text">
              <div>不支持长图翻译</div>
              <div class="feature-note">长图片、复杂排版文档翻译受限</div>
            </div>
          </div>
        </div>

        <button class="button free-button" @click="handleFreePlanClick">当前使用中</button>
      </div>

      <!-- VIP版卡片 -->
      <div class="plan-card vip-card">
        <div class="plan-badge vip-badge">推荐</div>
        <div class="plan-header">
          <h2 class="plan-name">VIP版</h2>
          <div class="plan-price vip-price">￥99<span class="price-period">/月</span></div>
          <p class="plan-description">适合专业翻译需求，享受高效无限制翻译体验</p>
        </div>

        <div class="features-list">
          <div class="feature">
            <div class="feature-icon vip-icon">
              <i class="fas fa-bolt"></i>
            </div>
            <div class="feature-text">
              <div>优先翻译，优先队列</div>
              <div class="feature-note">翻译任务优先处理，减少等待时间</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon vip-icon">
              <i class="fas fa-infinity"></i>
            </div>
            <div class="feature-text">
              <div>根据算力翻译，无数量限制</div>
              <div class="feature-note">每月赠送1500算力，翻译次数不受限制</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon vip-icon">
              <i class="fas fa-images"></i>
            </div>
            <div class="feature-text">
              <div>支持长图翻译</div>
              <div class="feature-note">可翻译长图片、复杂排版文档</div>
            </div>
          </div>

          <div class="feature">
            <div class="feature-icon vip-icon">
              <i class="fas fa-star"></i>
            </div>
            <div class="feature-text">
              <div>高级翻译功能</div>
              <div class="feature-note">专业术语库、上下文理解、格式保持</div>
            </div>
          </div>
        </div>

        <button class="button vip-button" @click="handleVipPlanClick">升级到VIP版</button>
      </div>
    </div>

    <!-- 功能对比表格 -->
    <div class="comparison-table">
      <h3 class="comparison-title">免费版与VIP版功能详细对比</h3>

      <div class="comparison-features">
        <div class="comparison-item">
          <div class="comparison-label">翻译队列优先级</div>
          <div class="comparison-free">
            <span class="badge free-badge">普通队列</span>
          </div>
          <div class="comparison-vip">
            <span class="badge vip-badge-text">优先队列</span>
          </div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">翻译数量限制</div>
          <div class="comparison-free">每天10次</div>
          <div class="comparison-vip">无限制</div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">长图翻译支持</div>
          <div class="comparison-free">不支持</div>
          <div class="comparison-vip">支持</div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">翻译速度</div>
          <div class="comparison-free">普通速度</div>
          <div class="comparison-vip">高速处理</div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">翻译算力</div>
          <div class="comparison-free">每日赠送20算力</div>
          <div class="comparison-vip">每月赠送1500算力</div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">技术支持</div>
          <div class="comparison-free">社区支持</div>
          <div class="comparison-vip">专属客服</div>
        </div>

        <div class="comparison-item">
          <div class="comparison-label">文件格式支持</div>
          <div class="comparison-free">基础格式</div>
          <div class="comparison-vip">20+种格式</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'

// VIP版升级按钮点击事件
const handleVipPlanClick = () => {
  // TODO: 跳转到VIP版订阅页面
  ElMessage.info('跳转到VIP版订阅页面，享受优先翻译服务！')
  console.log('跳转到VIP订阅页面')
}

// 免费版按钮点击事件
const handleFreePlanClick = () => {
  ElMessage.info('您正在使用免费版，升级VIP可享受更多权益！')
}
</script>

<style scoped>
/* 添加Font Awesome */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.header {
    text-align: center;
    margin-bottom: 50px;
}

h1 {
    font-size: 36px;
    margin-bottom: 15px;
    background: linear-gradient(90deg, #7c3aed, #3b82f6);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.subtitle {
    color: #9ca3af;
    font-size: 18px;
    max-width: 600px;
    margin: 0 auto 30px;
}

.plans-container {
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
    margin-bottom: 50px;
}

.plan-card {
    background: linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.9));
    border-radius: 20px;
    padding: 40px 30px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(75, 85, 99, 0.3);
    transition: transform 0.3s, box-shadow 0.3s;
    position: relative;
}

.plan-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
}

.free-card {
    border-top: 5px solid #3b82f6;
}

.vip-card {
    border-top: 5px solid #8b5cf6;
}

.plan-badge {
    position: absolute;
    top: 20px;
    right: 20px;
    background-color: #3b82f6;
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
}

.vip-badge {
    background-color: #8b5cf6;
}

.plan-header {
    margin-bottom: 30px;
}

.plan-name {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 10px;
}

.plan-price {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 5px;
}

.free-price {
    color: #3b82f6;
}

.vip-price {
    color: #8b5cf6;
}

.price-period {
    color: #9ca3af;
    font-size: 16px;
    font-weight: normal;
}

.plan-description {
    color: #9ca3af;
    margin-bottom: 30px;
    font-size: 16px;
}

.features-list {
    margin-bottom: 40px;
}

.feature {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
}

.feature-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    flex-shrink: 0;
}

.free-icon {
    color: #3b82f6;
}

.vip-icon {
    color: #8b5cf6;
}

.feature-text {
    font-size: 16px;
}

.feature-note {
    color: #9ca3af;
    font-size: 14px;
    margin-top: 5px;
}

.button {
    display: block;
    width: 100%;
    padding: 18px 20px;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
}

.free-button {
    background-color: #374151;
    color: white;
}

.free-button:hover {
    background-color: #4b5563;
}

.vip-button {
    background: linear-gradient(90deg, #7c3aed, #3b82f6);
    color: white;
}

.vip-button:hover {
    background: linear-gradient(90deg, #6d28d9, #2563eb);
    box-shadow: 0 5px 20px rgba(123, 97, 255, 0.3);
}

.comparison-table {
    background: linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.9));
    border-radius: 20px;
    padding: 40px 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(75, 85, 99, 0.3);
}

.comparison-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
}

.comparison-features {
    display: flex;
    flex-direction: column;
}

.comparison-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid rgba(75, 85, 99, 0.3);
}

.comparison-item:last-child {
    border-bottom: none;
}

.comparison-label {
    width: 40%;
    font-weight: 600;
    font-size: 16px;
}

.comparison-free, .comparison-vip {
    width: 30%;
    text-align: center;
}

.comparison-free {
    color: #3b82f6;
}

.comparison-vip {
    color: #8b5cf6;
}

.badge {
    display: inline-block;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
}

.free-badge {
    background-color: rgba(59, 130, 246, 0.2);
    color: #3b82f6;
}

.vip-badge-text {
    background-color: rgba(139, 92, 246, 0.2);
    color: #8b5cf6;
}

.highlight {
    color: #fbbf24;
    font-weight: 600;
}

@media (max-width: 768px) {
    .plans-container {
        flex-direction: column;
        align-items: center;
    }

    .plan-card {
        max-width: 100%;
    }

    .comparison-item {
        flex-direction: column;
        text-align: center;
        gap: 10px;
    }

    .comparison-label, .comparison-free, .comparison-vip {
        width: 100%;
    }
}
</style>